var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"icon":"preferences","title":_vm.__('Display'),"aria-label":_vm.__('Display'),"selected":_vm.selected,"data-testid":"display-settings-icon-button"},on:{"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }